var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2961_24229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00065 12.6667C4.00065 13.4 4.60065 14 5.33398 14H10.6673C11.4007 14 12.0007 13.4 12.0007 12.6667V6C12.0007 5.26667 11.4007 4.66667 10.6673 4.66667H5.33398C4.60065 4.66667 4.00065 5.26667 4.00065 6V12.6667ZM6.00065 6H10.0007C10.3673 6 10.6673 6.3 10.6673 6.66667V12C10.6673 12.3667 10.3673 12.6667 10.0007 12.6667H6.00065C5.63398 12.6667 5.33398 12.3667 5.33398 12V6.66667C5.33398 6.3 5.63398 6 6.00065 6ZM10.334 2.66667L9.86065 2.19333C9.74065 2.07333 9.56732 2 9.39398 2H6.60732C6.43398 2 6.26065 2.07333 6.14065 2.19333L5.66732 2.66667H4.00065C3.63398 2.66667 3.33398 2.96667 3.33398 3.33333C3.33398 3.7 3.63398 4 4.00065 4H12.0007C12.3673 4 12.6673 3.7 12.6673 3.33333C12.6673 2.96667 12.3673 2.66667 12.0007 2.66667H10.334Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2961_24229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/DeleteOutline.45b14e29ed41ea9d4cd4b3b9fee0f40e.svg";
export { ForwardRef as ReactComponent };